import type { FunctionComponent } from 'react';
import React, { useCallback } from 'react';

import { Analytics } from '@trello/atlassian-analytics';
import { forNamespace } from '@trello/i18n';
import { Spinner } from '@trello/nachos/spinner';

import { useFreeTrialEligibilityRules } from 'app/src/components/FreeTrial/useFreeTrialEligibilityRules';
import { useUpgradePromptRules } from 'app/src/components/UpgradePrompts/useUpgradePromptRules';

import styles from './BoardHeaderOrgMenuPopoverButton.less';

const format = forNamespace(['upgrade-path-audit']);

export const BoardHeaderOrgMenuPopoverButton: FunctionComponent<{
  orgId: string;
}> = ({ orgId }) => {
  const {
    isEligible,
    loading: loadingFreeTrial,
    isPremium,
    isEnterpriseMember,
  } = useFreeTrialEligibilityRules(orgId, { skip: !orgId });

  const {
    openPlanSelection,
    loading: loadingUpgradePrompt,
  } = useUpgradePromptRules(orgId, `board-header-org-menu-button-${orgId}`);

  const onClick = useCallback(() => {
    openPlanSelection();

    Analytics.sendClickedLinkEvent({
      linkName: 'bcUpgradePrompt',
      source: 'boardWorkspaceInlineDialog',
      containers: {
        organization: {
          id: orgId,
        },
      },
      attributes: {
        isFreeTrial: !!isEligible,
        promptId: 'newTeamInlinePrompt',
      },
    });
  }, [isEligible, openPlanSelection, orgId]);

  if (loadingFreeTrial || loadingUpgradePrompt) {
    return <Spinner centered />;
  }

  const text = isEligible
    ? format('try-trello-premium')
    : format('upgrade-workspace');

  if (isPremium || isEnterpriseMember) {
    return null;
  }
  return (
    <div className={styles.ctaDivider}>
      <a role="button" className={styles.ctaButton} onClick={onClick}>
        {text}
      </a>
    </div>
  );
};
